export type RestoreSource = "gcs" | "wip" | "clean";

export interface RestoreProbe {
  gcsAvailable: boolean;
  wipRestoreResult: "applied" | "stale" | "none" | "failed";
}

export function selectRestoreSource(probe: RestoreProbe): RestoreSource {
  if (probe.gcsAvailable) return "gcs";
  if (probe.wipRestoreResult === "applied") return "wip";
  return "clean";
}
